import { render, staticRenderFns } from "./ApiDocs.vue?vue&type=template&id=1a7496d8&scoped=true&"
import script from "./ApiDocs.vue?vue&type=script&lang=js&"
export * from "./ApiDocs.vue?vue&type=script&lang=js&"
import style0 from "./ApiDocs.vue?vue&type=style&index=0&id=1a7496d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7496d8",
  null
  
)

export default component.exports